<style>
button.dt-button,
div.dt-button,
a.dt-button,
input.dt-button {
  color: white;
  background-color: green;
}

button.dt-button:hover:not(.disabled),
div.dt-button:hover:not(.disabled),
a.dt-button:hover:not(.disabled),
input.dt-button:hover:not(.disabled) {
  background-color: rgb(127, 238, 127);
}

.remove-button {
  margin-left: 10px;
}

/* table .dropdown-menu {
    position: fixed !important;
    top: 50% !important;
    left: 92% !important;
    transform: translate(-92%, -50%) !important;
} */
/* .btn-group {  
    white-space: nowrap;              
}
.btn-group .btn {  
    float: none;
    display: inline-block;
}
 .btn + .dropdown-toggle { 
    margin-left: -4px;
}

@media screen and (max-width: 1400px) {
.table-responsive {
    border: 1px solid #ddd;
    margin-bottom: 15px;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
}
.table-responsive > .table {
    margin-bottom: 0;
}
.table-responsive > .table > thead > tr > th, .table-responsive > .table > tbody > tr > th, .table-responsive > .table > tfoot > tr > th, .table-responsive > .table > thead > tr > td, .table-responsive > .table > tbody > tr > td, .table-responsive > .table > tfoot > tr > td {
    white-space: nowrap;
}
} */

#nonberusahaAdminUPT_info,
#nonberusahaAdminUPT_paginate,
#nonberusahaAdminUPT_filter {
  display: none;
}
</style>
<template>
  <div>
    <div v-if="show" :show="show" class="text-center">
      <img :src="require('@/assets/loadingfish.gif')" alt="Loading..." width="150px" />
      <p id="cancel-label">Sedang memuat data...</p>

    </div>
    <div v-if="!show">
      <div class="d-flex justify-content-between">
        <div>
          <button type="button" class="btn btn-success" @click="exportData">
            <i class="fa fa-file-text-o"></i> Excel
          </button>
        </div>
        <div class="d-flex">
          <div class="d-flex">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mr-2 mb-0">Search: </label>
              <input v-model="search.value" type="text" class="form-control" id="search">
            </div>
            <div>
              <select v-model="search.field" class="form-control">
                <option value="nomor_permohonan">Nomor Pemohon</option>
                <option value="instansi_pemohon">Instansi Pemohon</option>
                <option value="jenis_kegiatan">Jenis Kegiatan</option>
                <option value="nama_perairan">Nama Perairan</option>
                <option value="provinsi">Provinsi</option>
                <!-- <option value="status_verdok">Status Verdok</option> -->
                <option value="status_permohonan">Status Permohonan</option>
                <option value="keterangan_status">Keterangan Status</option>
                <option value="tanggal_permohonan">Tgl. Permohonan</option>
                <option value="tanggal_lolos_verifikasi_administrasi">Tgl. Verdok</option>
                <option value="pic_name">PIC Pentek</option>
              </select>
            </div>
          </div>
          <div class="d-flex ml-4">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mb-0">Sort By: </label>
            </div>
            <div>
              <select v-model="sort.field" class="form-control">
                <option value="createdAt">Tgl. Dibuat</option>
                <option value="tanggal_permohonan">Tgl. Permohonan</option>
                <option value="tanggal_lolos_verifikasi_administrasi">Tgl. Verdok</option>
              </select>
            </div>
            <div class="ml-2">
              <select v-model="sort.direction" class="form-control">
                <option value="DESC">DESC</option>
                <option value="ASC">ASC</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table id="nonberusahaAdminUPT" class="table" style="width: 100%">
          <thead>
            <tr>
              <th>No</th>
              <th>Nomor Pemohon</th>
              <th>Instansi Pemohon</th>
              <th>Jenis Kegiatan</th>
              <th>Nama Perairan</th>
              <th>Provinsi</th>
              <!-- <th>Status Verdok</th> -->
              <th>Status Permohonan</th>
              <th>Keterangan Status</th>
              <th>Tgl. Permohonan</th>
              <th>Tgl. Verdok</th>
              <th v-if="tipe == 'Swasta'">Tgl. Berlaku Tagihan</th>
              <th v-if="tipe == 'Swasta'">Status Tagihan</th>
              <th>PIC Pentek</th>
              <th>File</th>
              <!-- <th>PIC Verdok</th> -->
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in dataPermohonan" :key="index"
              :class="[{ 'row-perbaikan': data.keterangan_status === 'Perbaikan Persyaratan' }]">
              <td>{{ index + pagination.firstInPage }}</td>
              <td>
                <span class="badge rounded-pill bg-success" style="font-size: 10px; font-weight: normal"
                  v-if="data.nomor_permohonan != null">{{ data.nomor_permohonan }}</span>
                <span class="badge rounded-pill bg-danger" style="
                  font-size: 10px;
                  font-weight: normal;
                  background-color: #ff6e7c !important;
                " v-else>Belum Ada</span>
              </td>
              <td style="
                word-wrap: break-word;
                min-width: 200px;
                max-width: 200px;
                white-space: normal;
              ">
                {{ data.instansi_pemohon }}
              </td>
              <td style="
                word-wrap: break-word;
                min-width: 200px;
                max-width: 200px;
                white-space: normal;
              ">
                <div :style="[
                  data.prioritas ? { color: 'green' } : { color: 'black' },
                ]">
                  {{ data.jenis_kegiatan }}
                </div>
              </td>
              <td>{{ data.nama_perairan }}</td>
              <td>{{ data.provinsi }}</td>
              <!-- <td>{{ data.status_verdok }}</td> -->
              <td>{{ data.status_permohonan }}</td>
              <td>{{ data.keterangan_status }}</td>
              <td>
                {{ format_date(data.tanggal_permohonan, "DD MMMM YYYY") }}
              </td>
              <td>
                {{
                  format_date(
                    data.tanggal_lolos_verifikasi_administrasi,
                    "DD MMMM YYYY"
                  )
                }}
              </td>
              <td v-if="tipe == 'Swasta'">
                <span v-if="data.status_tagihan_iii != null">
                  {{ format_date(data.tanggal_berlaku_hingga_tagihan_iii) }}
                </span>
                <span v-else-if="
                  data.status_tagihan_ii != null &&
                  data.status_tagihan_i != null
                ">
                  {{ format_date(data.tanggal_berlaku_hingga_tagihan_ii) }}
                </span>
                <span v-else>
                  {{ format_date(data.tanggal_berlaku_hingga_tagihan_i) }}
                </span>
              </td>
              <td v-if="tipe == 'Swasta'">
                <span v-if="data.status_tagihan_iii != null">
                  {{ data.status_tagihan_iii }}
                </span>
                <span v-else-if="
                  data.status_tagihan_ii != null &&
                  data.status_tagihan_i != null
                ">
                  {{ data.status_tagihan_ii }}
                </span>
                <span v-else>
                  {{ data.status_tagihan_i }}
                </span>
              </td>
              <td>
                {{ data.pic_name }}
              </td>
              <td>
                <div style="width: 250px">
                  <div class="row">
                    <div class="col-md-8">
                      <select v-model="data.selectedFile" style="width: 150px; margin-right: 10px" class="form-select"
                        aria-label="Default select example">
                        <option disabled value="">- Pilih File -</option>
                        <option value="verdok" :disabled="data.file_ba_verdok == null
                          ">
                          Verdok
                        </option>

                        <!-- Option File Tagihan -->
                        <option value="tagihan_1" :disabled="data.file_tagihan_i == null">
                          <i class="la la-edit"></i> Tagihan 1
                        </option>

                        <option value="tagihan_2" :disabled="data.file_tagihan_ii == null">
                          <i class="la la-edit"></i> Tagihan 2
                        </option>

                        <option value="tagihan_3" :disabled="data.file_tagihan_iii == null">
                          <i class="la la-edit"></i> Tagihan 3
                        </option>

                        <option value="pembayaran" :disabled="data.bukti_pembayaran == null">
                          Bukti Pembayaran
                        </option>
                        <option value="surattugas" :disabled="data.filename_final_surat_tugas == null &&
                          data.filename_konsep_surat_tugas == null
                          ">
                          Surat Tugas
                        </option>
                        <option value="undangan" :disabled="data.filename_final_undangan == null &&
                          data.filename_konsep_undangan == null
                          ">
                          Undangan
                        </option>
                        <option value="ba" :disabled="data.file_ba_vertek == null">
                          Berita Acara
                        </option>
                        <!-- <option value="memo" :disabled="data.file_final_memorandum == null &&
                        data.file_konsep_memorandum == null
                        ">
                        Memorendum
                      </option> -->

                        <option value="shp" :disabled="data.file_shp == null
                          ">
                          File SHP
                        </option>

                        <option value="resume" :disabled="data.file_resume_permohonan == null &&
                          data.file_resume_permohonan == null
                          ">
                          Resume Permohonan
                        </option>

                        <option value="persetujuan" :disabled="data.file_persetujuan == null">
                          Surat Persetujuan
                        </option>


                        <!-- <option value="final-persetujuan" :disabled="data.file_izin_ttd == null">
                        Final Surat Persetujuan
                      </option> -->
                      </select>
                    </div>
                    <div class="col-md-4 mt-2">

                      <span v-if="
                        data.file_resume_permohonan != null &&
                        data.selectedFile == 'resume'
                      ">
                        <a :href="data.file_resume_permohonan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file resume permohonan" />
                        </a>
                      </span>


                      <span v-if="
                        data.file_shp != null &&
                        data.selectedFile == 'shp'
                      ">
                        <a :href="data.file_shp" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top" title="Unduh file SHP" />
                        </a>
                      </span>

                      <span v-if="
                        data.file_ba_verdok != null &&
                        data.selectedFile == 'verdok'
                      ">
                        <a :href="data.file_ba_verdok" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file verifikasi dokumen" /></a>
                      </span>

                      <!-- Download File Tagihan -->
                      <span v-if="
                        data.file_tagihan_iii != null &&
                        data.selectedFile == 'tagihan_3'
                      ">
                        <a :href="data.file_tagihan_iii" target="_blank"><i class="fa fa-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file tagihan 3" /></a>
                      </span>
                      <span v-if="
                        data.file_tagihan_ii != null &&
                        data.selectedFile == 'tagihan_2'
                      ">
                        <a :href="data.file_tagihan_ii" target="_blank"><i class="fa fa-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file tagihan 2" />
                        </a>
                      </span>

                      <span v-if="
                        data.file_tagihan_i != null &&
                        data.selectedFile == 'tagihan_1'
                      ">
                        <a :href="data.file_tagihan_i" target="_blank"><i class="fa fa-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file tagihan 1" /></a>
                      </span>

                      <!-- <br> -->
                      <span v-if="
                        data.bukti_pembayaran != null &&
                        data.selectedFile == 'pembayaran'
                      ">
                        <a :href="data.bukti_pembayaran" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file bukti pembayaran" />
                        </a>
                      </span>

                      <span v-if="
                        data.filename_final_surat_tugas != null &&
                        data.selectedFile == 'surattugas'
                      ">
                        <a :href="data.filename_final_surat_tugas" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file surat tugas" /></a>
                      </span>
                      <span v-else-if="
                        data.filename_konsep_surat_tugas != null &&
                        data.selectedFile == 'surattugas'
                      ">
                        <a :href="data.filename_konsep_surat_tugas" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file surat tugas" /></a>
                      </span>

                      <span v-if="
                        data.filename_final_undangan != null &&
                        data.selectedFile == 'undangan'
                      ">
                        <a :href="data.filename_final_undangan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file undangan" /></a>
                      </span>
                      <span v-else-if="
                        data.filename_konsep_undangan != null &&
                        data.selectedFile == 'undangan'
                      ">
                        <a :href="data.filename_konsep_undangan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file undangan" /></a>
                      </span>

                      <span v-if="
                        data.file_ba_vertek != null && data.selectedFile == 'ba'
                      ">
                        <a :href="data.file_ba_vertek" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file berita acara" /></a>
                      </span>

                      <span v-if="
                        data.file_final_memorandum != null &&
                        data.selectedFile == 'memo'
                      ">
                        <a :href="data.file_final_memorandum" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file memo" /></a>
                      </span>
                      <span v-else-if="
                        data.file_konsep_memorandum != null &&
                        data.selectedFile == 'memo'
                      ">
                        <a :href="data.file_konsep_memorandum" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file memo" /></a>
                      </span>

                      <span v-if="
                        data.file_persetujuan != null &&
                        data.selectedFile == 'persetujuan'
                      ">
                        <a :href="data.file_persetujuan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file persetujuan" />
                        </a>
                      </span>

                      <span v-if="
                        data.file_izin_ttd != null &&
                        data.selectedFile == 'final-persetujuan'
                      ">
                        <a :href="data.file_izin_ttd" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file persetujuan" />
                        </a>
                      </span>
                    </div>
                  </div>

                  <!-- <b-form-select style="width: 150px;margin-right: 20px;" v-model="data.selectedFile"
                                    :options="optionsFile"></b-form-select> -->
                </div>
              </td>

              <!-- <td>
              <b-button
                variant="outline-primary"
                size="sm"
                v-b-modal.modal-pic-verdok-nonberusaha
                @click="
                  formpicverdok.id_pic_verdok = data.id_pic_verdok;
                  detailPICVerdok(data);
                "
                ><i
                  v-if="data.nama_pic_verdok != null"
                  class="fa fa-pencil"
                  aria-hidden="true"
                />
                <i v-else class="fa fa-plus" aria-hidden="true" />
                {{
                  data.nama_pic_verdok == null
                    ? "Belum Ada"
                    : data.nama_pic_verdok
                }}
              </b-button>
            </td> -->
              <td>
                <b-button size="sm" variant="info" data-toggle="tooltip" data-placement="top" title="Detail" @click="
                  $router.push('/app/nonberusaha/detail-perizinan/' + data.id)
                  " class="text-white"><i class="fa fa-eye" /> Detail</b-button>
                <b-button size="sm" class="m-1" variant="primary" @click="$emit('loadProgress', data.id)">
                  <i class="fa fa-search"></i> Tracking</b-button>

                <b-button size="sm" style="margin-left: 5px" variant="inverse" v-if="
                  (data.status_permohonan == 'Dokumen Lengkap' || data.status_permohonan == 'Menunggu Jadwal Penilaian Teknis') &&
                  data.id_admin === user.id
                " @click="
                getUndangan(data.id);
              getDataUser(data);
              getTTD(data.kode_wilayah_admin);
              " class="text-white" data-toggle="tooltip" data-placement="top" title="Jadwal Penilaian Teknis"><i
                    class="fa fa-file-text-o" />
                  <span v-if="
                    data.status_pembuatan_undangan == null ||
                    data.status_pembuatan_undangan ==
                    'Menunggu paraf persetujuan' ||
                    data.status_pembuatan_undangan == 'Menunggu tandatangan'
                  ">
                    Jadwal Pentek</span>
                  <span v-else-if="
                    data.status_pembuatan_undangan ==
                    'Catatan dari pemberi paraf'
                  ">
                    Perbaikan Jadwal</span>
                  <span v-else-if="
                    data.status_pembuatan_undangan == 'Sudah ditandatangani'
                  ">
                    Finalisasi Jadwal</span>
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between mt-4">
        <div>
          <template v-if="pagination.total">
            Menampilkan {{ pagination.firstInPage }} sampai {{ pagination.currentPage !== pagination.lastPage ?
              pagination.limit * pagination.currentPage : pagination.total }} dari {{ pagination.total }} data
          </template>
        </div>
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'first' })">
                <span aria-hidden="true">Awal</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'prev' })">
                <span aria-hidden="true">Sebelumnya</span>
              </a>
            </li>
            <li v-for="i in pagination.pageNumber" class="page-item">
              <a :class="['page-link', { 'active': i === `${pagination.currentPage}` }]" href="#"
                @click="changePage({ page: i })">{{ i }}</a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'next' })">
                <span aria-hidden="true">Selanjutnya</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'last' })">
                <span aria-hidden="true">Akhir</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <b-modal body-class="bg-white" id="modal-surat-tugas" scrollable title="Surat Tugas" cancel-title="Close"
      ok-title="Accept" size="lg" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col v-if="
            this.dataSuratTugas.status_pembuatan ==
            'Catatan dari penandatangan' ||
            this.dataSuratTugas.status_pembuatan ==
            'Catatan dari pemberi paraf'
          " md="12">
            <b-alert show variant="info">
              <span><span class="fw-semi-bold">Info:</span> Terdapat Catatan
                Perbaikan.
                <a type="button" data-toggle="modal" data-target=".catatan"
                  class="btn btn-default btn-xs float-end me-1" @click="getCatatanSurat">Lihat Catatan</a></span>
            </b-alert>
          </b-col>

          <b-col md="12">
            <div class="form-group">
              <b-form-group label="Kepada :">
                <v-select multiple v-model="dataSuratTugas.kepada" :options="dataUser" :reduce="(nama) => nama.id"
                  label="nama" />
              </b-form-group>
            </div>
          </b-col>

          <b-col md="12">
            <div class="form-group">
              <b-form-group label="Menimbang :">
                <ckeditor :editor="wygEditor" v-model="dataSuratTugas.menimbang"></ckeditor>
              </b-form-group>
            </div>
          </b-col>

          <b-col md="12">
            <div class="form-group">
              <b-form-group label="Dasar :">
                <ckeditor :editor="wygEditor" v-model="dataSuratTugas.dasar"></ckeditor>
              </b-form-group>
            </div>
          </b-col>

          <b-col md="12">
            <div class="form-group">
              <b-form-group label="Untuk :">
                <ckeditor :editor="wygEditor" v-model="dataSuratTugas.untuk"></ckeditor>
              </b-form-group>
            </div>
          </b-col>

          <b-col md="12">
            <div class="form-group">
              <b-form-group label="Catatan Surat :">
                <ckeditor :editor="wygEditor" v-model="dataSuratTugas.catatan_surat"></ckeditor>
              </b-form-group>
            </div>
          </b-col>

          <b-col md="6">
            <div class="form-group">
              <b-form-group label="Paraf Persetujuan :">
                <v-select v-model="dataSuratTugas.paraf_persetujuan" :options="dataTTD" :reduce="(nama) => nama.id_user"
                  label="nama_lengkap" />
              </b-form-group>
            </div>
          </b-col>

          <b-col md="6">
            <div class="form-group">
              <b-form-group label="Penandatangan :">
                <v-select v-model="dataSuratTugas.penandatangan" :options="dataTTD" :reduce="(nama) => nama.id_user"
                  label="nama_lengkap" />
              </b-form-group>
            </div>
          </b-col>

          <b-col md="12">
            <div class="form-group">
              <b-form-group label="Paragraf Penutup :">
                <ckeditor :editor="wygEditor" v-model="dataSuratTugas.paragraf_penutup"></ckeditor>
              </b-form-group>
            </div>
          </b-col>

          <b-col md="6">
            <div class="form-group">
              <b-form-group label="Tempat Tandatangan :">
                <b-form-input type="text" v-validate="'required'" name="tempat_ttd"
                  v-model="dataSuratTugas.tempat_ttd" />
              </b-form-group>
            </div>
          </b-col>

          <b-col md="6">
            <b-form-group label="Tanggal Surat: *">
              <input :class="{ 'form-control': true }" type="date" v-validate="'required'" name="Tanggal Surat"
                v-model="dataSuratTugas.tanggal_surat" />
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="simpanSuratTugas">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal catatan surat tugas -->
    <div class="modal fade catatan" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content" style="background-color: white">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Catatan</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: white">
            <div>
              <table id="example2" class="table" style="width: 100%">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Nama Pengirim</th>
                    <!-- <th>Jabatan Pengirim</th> -->
                    <th>Status</th>
                    <th>Catatan</th>
                    <th>Tanggal</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in dataCatatanSurat" :key="row.id">
                    <td></td>
                    <td>{{ row.nama_pengirim }}</td>
                    <!-- <td>
                                            {{row.jabatan_pengirim}}
                                        </td> -->
                    <td>
                      {{ row.status }}
                    </td>
                    <td>
                      <div v-html="row.isi_catatan"></div>
                    </td>
                    <td>
                      {{
                        new Date(row.createdAt).toLocaleDateString(
                          "id-ID",
                          options
                        )
                      }}
                      <br />
                      {{ new Date(row.createdAt).toLocaleTimeString() }}
                    </td>
                    <td>
                      <div>
                        <button data-toggle="modal" data-target="#modal-catatan" @click="getPerCatatan(row.id)"
                          style="margin: 5px" class="btn btn-secondary">
                          <i class="fa fa-eye"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- modal detail catatan -->
    <div class="modal fade" id="modal-catatan" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
      aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Detail Catatan {{ detailCatatan.nama_pengirim }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: white">
            <form ref="form" @submit.stop.prevent="tambahcatatan">
              <b-col md="12">
                <div class="form-group">
                  <b-form-group label="Detail Catatan :">
                    <!-- <b-form-textarea
                                            id="textarea-formatter"
                                            v-html="detailCatatan.isi_catatan "
                                            
                                        ></b-form-textarea> -->
                    <ckeditor :editor="wygEditor" v-model="detailCatatan.isi_catatan"></ckeditor>
                  </b-form-group>
                </div>
              </b-col>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- nomor surat tugas -->
    <b-modal body-class="bg-white" id="modal-final-surat" title="Surat Tugas" cancel-title="Close" ok-title="Accept"
      size="md" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="Nomor Surat: *">
              <input :class="{ 'form-control': true }" type="txt" v-validate="'required'" name="Nomor Surat"
                v-model="dataSuratTugas.nomor_surat" />
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="finalSuratTugas">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal jadwal vertek -->
    <b-modal body-class="bg-white" id="modal-jadwal" title="Jadwal Penilaian Teknis" cancel-title="Close"
      ok-title="Accept" size="lg" scrollable cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col v-if="
            this.dataUndangan.status_pembuatan == 'Catatan dari penandatangan'
          " md="12">
            <b-alert show variant="info">
              <span><span class="fw-semi-bold">Info:</span> Terdapat Catatan
                Perbaikan.
                <a type="button" data-toggle="modal" data-target=".catatan-undangan"
                  class="btn btn-default btn-xs float-end me-1" @click="getCatatanUndangan">Lihat Catatan</a></span>
            </b-alert>
          </b-col>

          <b-col md="12">
            <b-form-group label="Pilih PIC: *" label-for="username">
              <v-select id="default-select" :reduce="(user) => user.id" label="nama" v-model="dataPerDokumen.pic_id"
                :options="dataUserPIC" v-validate="'required'" name="PIC"
                :class="{ 'is-invalid': errors.has('form-1.PIC') }" />
              <span class="text-danger" v-if="errors.has('form-1.PIC')">
                {{ errors.first("form-1.PIC") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col v-if="dataPerDokumen.kode_wilayah_admin != 1" md="12">
            <b-form-group label="Pilih PIC Monitoring: *" label-for="username">
              <v-select id="default-select" :reduce="(user) => user.id" label="nama"
                v-model="dataPerDokumen.pic_monitor_id" :options="dataUserPICMonitor" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="Jadwal Penilaian Teknis *" label-for="username">
              <input type="date" v-model="dataPerDokumen.jadwal_verifikasi_teknis" class="form-control"
                v-validate="'required'" name="Jadwal Penilaian Teknis" :class="{
                  'form-control': true,
                  'is-invalid': errors.has('form-1.Jadwal Penilaian Teknis'),
                }" />
              <span class="text-danger" v-if="errors.has('form-1.Jadwal Penilaian Teknis')">
                {{ errors.first("form-1.Jadwal Penilaian Teknis") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="Waktu Penilaian Teknis *" label-for="username">
              <b-form-timepicker v-model="dataPerDokumen.waktu_verifikasi_teknis" v-validate="'required'"
                name="Waktu Penilaian Teknis" :class="{
                  'form-control': true,
                  'is-invalid': errors.has('form-1.Waktu Penilaian Teknis'),
                }"></b-form-timepicker>
              <span class="text-danger" v-if="errors.has('form-1.Waktu Penilaian Teknis')">
                {{ errors.first("form-1.Waktu Penilaian Teknis") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="File Undangan" label-for="file-undangan">


              <div class="border border-primary rounded p-4 text-center" @dragover.prevent @drop.prevent="handleDrop"
                style="width: 100%;height: 100%;">
                <div class="mb-3">
                  <i class="fa fa-download text-primary fs-1"></i>
                </div>
                <p class="mb-3">Select a file or drag here</p>



                <div class="d-flex gap-2 justify-content-center">
                  <div
                    v-if="dataPerDokumen.filename_final_undangan && typeof dataPerDokumen.filename_final_undangan === 'string'">
                    <a :href="dataPerDokumen.filename_final_undangan" target="_blank" class="btn btn-dark"><i
                        class="fa fa-file"></i> Lihat file saat ini</a>
                  </div>
                  <div>
                    <label class="btn btn-primary">
                      <i class="fa fa-upload"></i>
                      Select a file
                      <b-form-file v-model="dataPerDokumen.filename_final_undangan" name="File Undangan" :class="{
                        'form-control': false,
                        'is-invalid': errors.has('form-1.File Undangan'),
                      }" class="d-none" @change="handleFileChange"></b-form-file>
                      <!-- <input type="file" class="d-none" @change="handleFileChange" /> -->
                    </label>
                  </div>
                </div>


                <div v-if="selectedFileUndangan" class="mt-3 text-muted">
                  File selected: {{ selectedFileUndangan.name }}
                </div>
              </div>
              <span class="text-danger" v-if="errors.has('form-1.File Undangan')">
                {{ errors.first("form-1.File Undangan") }}
              </span>

              <!-- <b-form-file v-model="dataPerDokumen.filename_final_undangan" v-validate="'required'" name="File Undangan"
                :class="{
                  'form-control': false,
                  'is-invalid': errors.has('form-1.File Undangan'),
                }"></b-form-file>
              <span class="text-danger" v-if="errors.has('form-1.File Undangan')">
                {{ errors.first("form-1.File Undangan") }}
              </span> -->

            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="File Surat Tugas" label-for="file-st">

              <div class="border border-primary rounded p-4 text-center" @dragover.prevent @drop.prevent="handleDropST"
                style="width: 100%;height: 100%;">
                <div class="mb-3">
                  <i class="fa fa-download text-primary fs-1"></i>
                </div>
                <p class="mb-3">Select a file or drag here</p>



                <div class="d-flex gap-2 justify-content-center">
                  <div
                    v-if="dataPerDokumen.filename_final_surat_tugas && typeof dataPerDokumen.filename_final_surat_tugas === 'string'">
                    <a :href="dataPerDokumen.filename_final_surat_tugas" target="_blank" class="btn btn-dark"><i
                        class="fa fa-file"></i> Lihat file saat ini</a>
                  </div>
                  <div>
                    <label class="btn btn-primary">
                      <i class="fa fa-upload"></i>
                      Select a file
                      <b-form-file v-model="dataPerDokumen.filename_final_surat_tugas" name="File Surat Tugas" :class="{
                        'form-control': false,
                        'is-invalid': errors.has('form-1.File Surat Tugas'),
                      }" class="d-none" @change="handleFileChangeST"></b-form-file>
                    </label>
                  </div>
                </div>


                <div v-if="selectedFileST" class="mt-3 text-muted">
                  File selected: {{ selectedFileST.name }}
                </div>
              </div>
              <span class="text-danger" v-if="errors.has('form-1.File Surat Tugas')">
                {{ errors.first("form-1.File Surat Tugas") }}
              </span>

            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="onSubmitJadwal">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- nomor surat vertek -->
    <b-modal body-class="bg-white" id="modal-final-undangan" title="Jadwal Penilaian Teknis" cancel-title="Close"
      ok-title="Accept" size="md" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="Nomor Surat: *">
              <input :class="{ 'form-control': true }" type="txt" v-validate="'required'" name="Nomor Surat"
                v-model="dataUndangan.nomor_surat" />
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="finalUndangan">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal catatan vertek -->
    <div class="modal fade catatan-undangan" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content" style="background-color: white">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Catatan</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: white">
            <div>
              <table id="example3" class="table" style="width: 100%">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Nama Pengirim</th>
                    <!-- <th>Jabatan Pengirim</th> -->
                    <th>Status</th>
                    <th>Catatan</th>
                    <th>Tanggal</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in dataCatatanUndangan" :key="row.id">
                    <td></td>
                    <td>{{ row.nama_pengirim }}</td>
                    <!-- <td>
                                            {{row.jabatan_pengirim}}
                                        </td> -->
                    <td>
                      {{ row.status }}
                    </td>
                    <td>
                      <div v-html="row.isi_catatan"></div>
                    </td>
                    <td>
                      {{
                        new Date(row.createdAt).toLocaleDateString(
                          "id-ID",
                          options
                        )
                      }}
                      <br />
                      {{ new Date(row.createdAt).toLocaleTimeString() }}
                    </td>
                    <td>
                      <div>
                        <button data-toggle="modal" data-target="#modal-catatan-undangan"
                          @click="getPerCatatanUndangan(row.id)" style="margin: 5px" class="btn btn-secondary">
                          <i class="fa fa-eye"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- modal detail catatan -->
    <div class="modal fade" id="modal-catatan-undangan" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLongTitle" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Detail Catatan {{ detailCatatanUndangan.nama_pengirim }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: white">
            <form ref="form" @submit.stop.prevent="tambahcatatan">
              <b-col md="12">
                <div class="form-group">
                  <b-form-group label="Detail Catatan :">
                    <!-- <b-form-textarea
                                            id="textarea-formatter"
                                            v-html="detailCatatan.isi_catatan "
                                            
                                        ></b-form-textarea> -->
                    <ckeditor :editor="wygEditor" v-model="detailCatatanUndangan.isi_catatan"></ckeditor>
                  </b-form-group>
                </div>
              </b-col>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-pic-verdok-nonberusaha" size="sm" body-class="bg-white" title="PIC Verifikasi Dokumen">
      <b-form-group label="Nama Admin" label-for="username">
        <v-select id="default-select" :reduce="(data) => data.id" label="nama" v-model="formpicverdok.id_pic_verdok"
          :options="dataUserPICVerdok" v-validate="'required'" name="Admin"
          :class="{ 'is-invalid': errors.has('form-1.Admin') }" />
        <span class="text-danger" v-if="errors.has('form-1.Admin')">
          {{ errors.first("form-1.Admin") }}
        </span>
      </b-form-group>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="danger" size="sm" class="float-right m-1"
            @click="$bvModal.hide('modal-pic-verdok-nonberusaha')">
            Tutup
          </b-button>

          <b-button variant="primary" size="sm" class="float-right m-1" @click="simpanPICVerdok">
            Simpan
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import moment from "moment";
import axios from "axios";
import vSelect from "vue-select";
import Swal from "sweetalert2";
import VueLoading from "vuejs-loading-plugin";
import * as xlsx from "xlsx";

// using default options
Vue.use(VueLoading);

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: "Loading", // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: "rgb(255,255,255)", // set custom background
  classes: ["myclass"], // array, object or string
});
export default {
  components: { vSelect },
  data() {
    return {
      fields: [
        "no",
        { key: "nama_pemohon", sortable: true },
        { key: "nomor_permohonan", sortable: true },
        { key: "jenis_kegiatan", sortable: true },
        { key: "status_verdok", label: "Status", sortable: true },
        { key: "tanggal_pada_permohonan", label: "Tanggal Permohonan" },
        { key: "file_undangan", label: "Undangan Pentek" },
        "Aksi",
      ],
      optionsDatatable: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: "", count: "", limit: "" },
        columnsClasses: { id: "width-100" },
        skin: "table table-striped",
        sortIcon: {
          base: "fa text-muted",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
      },
      optionsFile: [
        { value: null, text: "- Unduh file -" },
        { value: "tagihan", text: "Tagihan" },
        { value: "pembayaran", text: "Bukti Pembayaran" },
        { value: "surattugas", text: "Surat Tugas" },
        { value: "undangan", text: "Undangan" },
        { value: "ba", text: "Berita Acara" },
        { value: "memo", text: "Memo" },
        { value: "persetujuan", text: "Persetujuan" },
      ],

      // currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      wygEditor: ClassicEditor,
      dataSuratTugas: [],
      dataUser: [],
      dataTTD: [],
      id_Permohonan: null,
      dataCatatanSurat: [],
      detailCatatan: [],
      dataPerDokumen: [],
      dataUndangan: [],
      dataCatatanUndangan: [],
      detailCatatanUndangan: [],
      dataUserPIC: [],
      dataUserPICMonitor: [],
      dataPermohonan: [],
      popoverShow: {},
      dataKL: [],
      dataPemda: [],
      dataUserPICVerdok: [],
      formpicverdok: {
        id: null,
        id_pic_verdok: null,
      },

      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: null,
        pageNumber: [],
        limit: 0,
        total: 0,
        firstInPage: 0,
      },
      search: {
        field: "nomor_permohonan",
        value: "",
      },
      sort: {
        field: "tanggal_permohonan",
        direction: "DESC",
      },
      debounceTerm: null,
      selectedFileUndangan: null,
      selectedFileST: null,
      show: false
    };
  },
  props: {
    itemsWithNumber: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // dataTTD: {
    //   type: Array,
    //   default: () => {
    //     return [];
    //   },
    // },

    tipe: String,
    rows: Number,

    totalRows: Number,
    currentPage: Number,
    user: Object,
    baseapi: String,
  },
  mounted() {
    this.getdata();
    this.getDataKL();
    this.getDataPemda();
    this.getDataUserAdmin();
    // this.initDataTable();
    // $(window).on("resize", this.initDataTable);
    // this.getDataUser()

    // $('.table-responsive').on('show.bs.dropdown', function () {
    //         $('.table-responsive').css( "overflow", "inherit" );
    //     });

    //     $('.table-responsive').on('hide.bs.dropdown', function () {
    //         $('.table-responsive').css( "overflow", "auto" );
    //     })
  },
  watch: {
    search: {
      handler: function (val) {
        if (this.debounceTerm) {
          clearTimeout(this.debounceTerm)
        }
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.getdata();
        }, 1000)
      },
      deep: true,
    },
    sort: {
      handler: function (val) {
        this.pagination.currentPage = 1
        this.getdata();
      },
      deep: true,
    },
  },
  // beforeDestroy() {
  //   $(window).off("resize", this.initDataTable);
  // if ($.fn.DataTable.isDataTable("#tablesatu")) {
  //   $("#tablesatu").DataTable().destroy();
  // }
  // },
  methods: {
    handleFileChange(event) {
      this.selectedFileUndangan = event.target.files[0];
    },
    handleDrop(event) {
      const files = event.dataTransfer.files;
      if (files.length) {
        this.selectedFileUndangan = files[0];
      }
    },
    handleFileChangeST(event) {
      this.selectedFileST = event.target.files[0];
    },
    handleDropST(event) {
      const files = event.dataTransfer.files;
      if (files.length) {
        this.selectedFileST = files[0];
      }
    },
    onClose(id) {
      this.popoverShow[id] = false;
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD MMMM YYYY");
      }
    },

    getSuratTugas(id, kode_wilayah_admin) {
      axios
        .get(
          this.baseapi +
          "api/surat_tugas_nonberusaha?filter=id_permohonan,=," +
          id,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          if (response.data.data.length == 0) {
            this.dataSuratTugas = [];
          } else {
            this.dataSuratTugas = response.data.data[0];
          }
          this.dataUser = [];
          console.log(this.dataSuratTugas);
          this.getTTD(kode_wilayah_admin);
          this.getUser(kode_wilayah_admin);
          this.id_Permohonan = id;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getTTD(kode_wilayah_admin) {
      axios
        .get(
          this.baseapi +
          "api/tandatangan?filter=kode_provinsi,=," +
          kode_wilayah_admin,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataTTD = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getDataKL() {
      axios
        .get(this.baseapi + "api/kementerian", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKL = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getDataPemda() {
      axios
        .get(this.baseapi + "api/dinas_pemda", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPemda = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get data user
    getDataUser(data) {
      let apiPIC;
      let apiPICMonitor;
      if (data.kode_wilayah_admin === 1) {
        apiPIC = "api/user?filter=role,=,pic";
        axios
          .get(this.baseapi + apiPIC, {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          })
          .then((response) => {
            this.dataUserPIC = response.data.data;
          })
          .catch((error) => {
            console.log(error);
            return error;
          });
      } else {
        apiPIC =
          "api/user?filter=role,=,pic_upt;kode_provinsi,=," +
          data.kode_wilayah_admin;
        axios
          .get(this.baseapi + apiPIC, {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          })
          .then((response) => {
            this.dataUserPIC = response.data.data;
          })
          .catch((error) => {
            console.log(error);
            return error;
          });

        apiPICMonitor = "api/user?filter=role,=,pic_monitor;kode_provinsi,=," +
        data.kode_wilayah_admin;
        axios
          .get(this.baseapi + apiPICMonitor, {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          })
          .then((response) => {
            this.dataUserPICMonitor = response.data.data;
          })
          .catch((error) => {
            console.log(error);
            return error;
          });
      }
    },

    getUser(kode_wilayah_admin) {
      axios
        .get(
          this.baseapi +
          "api/user?filter=kode_provinsi,=," +
          kode_wilayah_admin +
          ";role,!=,pemohon",
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataUser = response.data.data;
          console.log(this.dataUser);
          if (this.dataSuratTugas.length == 0) {
            this.$bvModal.show("modal-surat-tugas");
          } else {
            if (
              this.dataSuratTugas.status_pembuatan ==
              "Menunggu paraf persetujuan"
            ) {
              this.$bvModal.show("modal-surat-tugas");
            } else if (
              this.dataSuratTugas.status_pembuatan ==
              "Catatan dari pemberi paraf" ||
              this.dataSuratTugas.status_pembuatan ==
              "Catatan dari penandatangan"
            ) {
              this.getCatatanSurat();
              Swal.fire({
                icon: "question",
                title: "Silahkan Pilih",
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: "Unduh Surat",
                denyButtonText: `Perbaikan Surat`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  window.open(this.dataSuratTugas.filename_konsep, "_blank");
                } else if (result.isDenied) {
                  this.$bvModal.show("modal-surat-tugas");
                }
              });
            } else if (
              this.dataSuratTugas.status_pembuatan == "Sudah ditandatangani"
            ) {
              this.$bvModal.show("modal-final-surat");
            } else if (this.dataSuratTugas.status_pembuatan == "Selesai") {
              Swal.fire({
                icon: "info",
                title: "Unduh Surat Tugas",
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: "Unduh",
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  window.open(this.dataSuratTugas.filename_final, "_blank");
                }
              });
            } else {
              Swal.fire({
                icon: "info",
                title: this.dataSuratTugas.status_pembuatan,
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getCatatanSurat() {
      $("#example2").DataTable().destroy();
      axios
        .get(
          this.baseapi +
          "api/catatan_st?filter=id_st,=," +
          this.dataSuratTugas.id,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataCatatanSurat = response.data.data;
          this.initDatatable2();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getPerCatatan(id) {
      axios
        .get(this.baseapi + "api/catatan_st/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.detailCatatan = [];
          this.detailCatatan.nama_pengirim = response.data.data.nama_pengirim;
          if (response.data.data.isi_catatan == null) {
            this.detailCatatan.isi_catatan = "";
          } else {
            this.detailCatatan.isi_catatan = response.data.data.isi_catatan;
          }
          console.log(this.detailCatatan);
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    initDatatable2() {
      setTimeout(() => {
        var t = "#example2".DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          // order: [[0, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: {
            left: 2,
            right: 1,
          },
          scrollX: true,
          // dom: 'Bfrtip',
          // "fnRowCallback": function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          //     //debugger;
          //     var index = iDisplayIndexFull + 1;
          //     $("td:first", nRow).html(index);
          //     return nRow;
          //   },
          //   columnDefs: [{
          //     targets: 0,
          //     render: function(data, type, row, meta) {
          //     console.log(meta.row);
          //     console.log(type == 'export'? meta.row : data);
          //       return type == 'export'? meta.row + 1 : data;
          //     }
          //   }],
        });

        // t.on( 'click', 'button', function (e) {
        //     var closestRow = $(this).closest('tr');
        //     var data = t.row( $(this).parents(closestRow)).data();
        //     alert(data[0])
        //     // alert( t.cell( $(this).closest('tr').prev('tr'), $(this).attr('data-dtr-index') ).data() );
        // e.stopPropagation();

        // } );
        t.on("order.dt search.dt", function () {
          t.column(0, { search: "applied", order: "applied" })
            .nodes()
            .each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
        }).draw();
      }, 300);
    },

    getCatatanUndangan() {
      $("#example3").DataTable().destroy();
      axios
        .get(
          this.baseapi +
          "api/catatan_undangan?filter=id_undangan,=," +
          this.dataUndangan.id,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataCatatanUndangan = response.data.data;
          this.initDatatable3();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getPerCatatanUndangan(id) {
      axios
        .get(this.baseapi + "api/catatan_undangan/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.detailCatatanUndangan = [];
          this.detailCatatanUndangan.nama_pengirim =
            response.data.data.nama_pengirim;
          if (response.data.data.isi_catatan == null) {
            this.detailCatatanUndangan.isi_catatan = "";
          } else {
            this.detailCatatanUndangan.isi_catatan =
              response.data.data.isi_catatan;
          }
          console.log(this.detailCatatanUndangan);
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    initDatatable3() {
      setTimeout(() => {
        var t = $("#example3").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          // order: [[0, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: {
            left: 2,
            right: 1,
          },
          scrollX: true,
          // dom: 'Bfrtip',
          // "fnRowCallback": function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          //     //debugger;
          //     var index = iDisplayIndexFull + 1;
          //     $("td:first", nRow).html(index);
          //     return nRow;
          //   },
          //   columnDefs: [{
          //     targets: 0,
          //     render: function(data, type, row, meta) {
          //     console.log(meta.row);
          //     console.log(type == 'export'? meta.row : data);
          //       return type == 'export'? meta.row + 1 : data;
          //     }
          //   }],
        });

        // t.on( 'click', 'button', function (e) {
        //     var closestRow = $(this).closest('tr');
        //     var data = t.row( $(this).parents(closestRow)).data();
        //     alert(data[0])
        //     // alert( t.cell( $(this).closest('tr').prev('tr'), $(this).attr('data-dtr-index') ).data() );
        // e.stopPropagation();

        // } );
        t.on("order.dt search.dt", function () {
          t.column(0, { search: "applied", order: "applied" })
            .nodes()
            .each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
        }).draw();
      }, 300);
    },

    // getDetailPerDokumen(data){
    //     this.$emit('getDetailPerDokumen', data)
    // },

    // simpan jadwal vertek
    onSubmitJadwal() {

      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-jadwal");
          });

          this.$loading(true);
          var formData = new FormData()
          formData.append("pic_id", this.dataPerDokumen.pic_id)
          formData.append("pic_monitor_id", this.dataPerDokumen.pic_monitor_id)
          formData.append("jadwal_verifikasi_teknis", this.dataPerDokumen.jadwal_verifikasi_teknis)
          formData.append("waktu_verifikasi_teknis", this.dataPerDokumen.waktu_verifikasi_teknis)
          if (this.dataPerDokumen.filename_final_undangan instanceof File) {
            formData.append("filename_final_undangan", this.dataPerDokumen.filename_final_undangan)
          }
          if (this.dataPerDokumen.filename_final_surat_tugas instanceof File) {
            formData.append("filename_final_surat_tugas", this.dataPerDokumen.filename_final_surat_tugas)
          }
          axios
            .post(
              this.baseapi + "api/permohonan_nonberusaha/jadwalkanVertek/" + this.dataPerDokumen.id, formData,
              {
                // status_tandatangan_undangan: true,

                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              Swal.fire({
                title: "Berhasil!",
                text: "Jadwal berhasil disimpan!",
                icon: "success"
              });

              this.getdata()
              return res;
            })
            .catch((err) => {
              console.log(err);
              Swal.fire({
                title: "Gagal!",
                text: err.response.data.message,
                icon: "error"
              });
              return err;
            }).finally(() => {
              this.$loading(false);
              this.selectedFileST = null
              this.selectedFileUndangan = null
            });
        }
      });
    },

    onSubmitUndangan() {
      let api = "";
      if (this.dataUndangan.id == null) {
        api = "api/undangan_nonberusaha";
        this.$loading(true);
        axios
          .post(
            this.baseapi + api,
            {
              id_permohonan: this.dataPerDokumen.id,
              tanggal_surat: this.dataUndangan.tanggal_surat,
              jenis_pertemuan: this.dataUndangan.jenis_pertemuan,
              alamat: this.dataUndangan.alamat,
              url_bahan_rapat: this.dataUndangan.url_bahan_rapat,
              penandatangan: this.dataUndangan.penandatangan,
              diundang_kl: this.dataUndangan.diundang_kl,
              diundang_pemda: this.dataUndangan.diundang_pemda,
              diundang_pemohon: this.dataUndangan.diundang_pemohon,
              meeting_id: this.dataUndangan.meeting_id,
              passcode: this.dataUndangan.passcode,
            },
            {
              // status_tandatangan_undangan: true,
              headers: {
                "Content-type": "application/json",
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          .then((res) => {
            this.$loading(false);
            this.dataPerDokumen = [];
            this.dataUndangan = [];
            this.getdata();
            // Wait until the models are updated in the UI

            // this.downloadUndangan(res.data.data.file_undangan)
            this.$toasted.success("Berhasil Disimpan");
            return res;
          })
          .catch((err) => {
            console.log(err);
            this.$loading(false);
            this.$toasted.error(err.response.data.message);
            return err;
          });
      } else {
        this.$loading(true);
        api = "api/undangan_nonberusaha/" + this.dataUndangan.id;
        axios
          .put(
            this.baseapi + api,
            {
              id_permohonan: this.dataPerDokumen.id,
              tanggal_surat: this.dataUndangan.tanggal_surat,
              jenis_pertemuan: this.dataUndangan.jenis_pertemuan,
              alamat: this.dataUndangan.alamat,
              url_bahan_rapat: this.dataUndangan.url_bahan_rapat,
              penandatangan: this.dataUndangan.penandatangan,
              diundang_kl: this.dataUndangan.diundang_kl,
              diundang_pemda: this.dataUndangan.diundang_pemda,
              diundang_pemohon: this.dataUndangan.diundang_pemohon,
              meeting_id: this.dataUndangan.meeting_id,
              passcode: this.dataUndangan.passcode,
            },
            {
              // status_tandatangan_undangan: true,
              headers: {
                "Content-type": "application/json",
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          .then((res) => {
            this.$loading(false);
            this.dataPerDokumen = [];
            this.dataUndangan = [];
            this.getdata();
            // Wait until the models are updated in the UI
            this.$toasted.success("Berhasil Disimpan");

            // this.downloadUndangan(res.data.data.file_undangan)
            return res;
          })
          .catch((err) => {
            console.log(err);
            this.$loading(false);
            this.$toasted.error(err.response.data.message);
            return err;
          });
      }
    },

    getUndangan(id) {
      axios
        .get(
          this.baseapi +
          "api/undangan_nonberusaha?filter=id_permohonan,=," +
          id,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          if (response.data.data.length == 0) {
            this.dataUndangan = [];
          } else {
            this.dataUndangan = response.data.data[0];
          }
          this.getDetailPerDokumen(id);
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getDetailPerDokumen(id) {
      axios
        .get(this.baseapi + "api/permohonan_nonberusaha/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPerDokumen = response.data.data;

          let arrayKl = [];
          let arrayPemda = [];
          let arrayPemohon = [];
          if (this.dataUndangan.length == 0) {
            this.$bvModal.show("modal-jadwal");
          } else {
            if (this.dataUndangan.status_pembuatan == "Menunggu tandatangan") {
              this.$bvModal.show("modal-jadwal");
            } else if (
              this.dataUndangan.status_pembuatan == "Catatan dari penandatangan"
            ) {
              Swal.fire({
                icon: "question",
                title: "Silahkan Pilih",
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: "Unduh Undangan",
                denyButtonText: `Perbaikan Jadwal`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  window.open(this.dataUndangan.filename_konsep, "_blank");
                } else if (result.isDenied) {
                  this.$bvModal.show("modal-jadwal");
                }
              });
            } else if (
              this.dataUndangan.status_pembuatan == "Sudah ditandatangani"
            ) {
              this.$bvModal.show("modal-final-undangan");
            } else if (this.dataUndangan.status_pembuatan == "Selesai") {
              Swal.fire({
                title: "Unduh Jadwal Penilaian Teknis",
                icon: "info",
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: "Unduh",
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  window.open(this.dataUndangan.filename_final, "_blank");
                }
              });
            } else {
              Swal.fire({
                icon: "info",
                title: this.dataUndangan.status_pembuatan,
              });
            }
          }
          //   if (this.dataUndangan.diundang_kl != null) {
          //     arrayKl = this.dataUndangan.diundang_kl.split("||")
          //   }
          //   if (this.dataUndangan.diundang_pemda != null) {
          //     arrayPemda = this.dataUndangan.diundang_pemda.split("||")
          //   }
          //   if (this.dataUndangan.diundang_pemohon != null) {
          //     arrayPemohon = this.dataUndangan.diundang_pemohon.split("||")
          //   }

          //   // if (this.dataUndangan.alamat != null) {
          //   //   if (this.dataUndangan.alamat.includes('||') == true) {
          //   //     arrayAlamat = this.dataUndangan.alamat.split("||")

          //   //     this.dataUndangan['meet_id'] = arrayAlamat[0]
          //   //     this.dataUndangan['passcode'] = arrayAlamat[1]
          //   //   } else {
          //   //     this.dataUndangan.alamat = this.dataUndangan.alamat
          //   //   }
          //   // }

          //   // if (this.dataUndangan.alamat.includes('||') == true) {
          //   //   console.log('test')
          //   // }
          //   this.dataUndangan.diundang_kl = arrayKl
          //   this.dataUndangan.diundang_pemda = arrayPemda
          //   this.dataUndangan.diundang_pemohon = arrayPemohon
          console.log(this.dataUndangan);
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    async getdata() {
      $("#nonberusahaAdminUPT").DataTable().destroy();
      // this.getDataUser()
      return this.loaddata();
    },

    loaddata() {
      this.show = true
      this.dataPermohonan = []
      // const api =
      //   "api/permohonan_nonberusaha?filter=tipe_pemohon,=," +
      //   this.tipe +
      //   ";id_admin,=," +
      //   this.user.id+";status_permohonan,!=,Permohonan telah dibuat oleh pemohon";
      // const api = `api/permohonan_nonberusaha/dataTable?page=${this.pagination.currentPage}&filter=tipe_pemohon,=,${this.tipe};id_admin,=,${this.user.id};status_permohonan,!=,Permohonan telah dibuat oleh pemohon;${this.search.field},like,${this.search.value}`
      const api = `api/permohonan_nonberusaha/dataTable` +
        `?page=${this.pagination.currentPage}` +
        `&filter=tipe_pemohon,=,${this.tipe};id_admin,=,${this.user.id};status_permohonan,!=,Permohonan telah dibuat oleh pemohon${this.search.value !== '' ? `;${this.search.field},${this.search.field === 'tanggal_permohonan' || this.search.field === 'tanggal_lolos_verifikasi_administrasi' ? '>=' : 'like'},${this.search.value}` : ''}` +
        `&sort=${this.sort.field},${this.sort.direction}`
      axios
        .get(this.baseapi + api, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          const data = response.data
          this.pagination.limit = data.limit
          this.pagination.total = data.total
          this.pagination.firstInPage = (this.pagination.currentPage - 1) * data.limit + 1
          this.pagination.lastPage = Math.ceil(data.total / data.limit)
          this.setPagination()
          this.dataPermohonan = response.data.data;

          for (let index = 0; index < this.dataPermohonan.length; index++) {
            Vue.set(this.dataPermohonan[index], "selectedFile", null);
          }
          this.initDatatable();
        })
        .catch((error) => {
          console.log(error);
          return error;
        }).finally(() => {
          this.show = false
        });
    },

    setPagination() {
      this.$router.replace({
        path: this.$route.path,
        query: { page: this.pagination.currentPage },
      }).catch((err) => { })
      this.pagination.pageNumber = []
      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('2')
          this.pagination.pageNumber.push('3')
          this.pagination.pageNumber.push('4')
          this.pagination.pageNumber.push('5')
        } else if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 4}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 3}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 2}`)
        } else {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.currentPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage + 1}`)
        }
        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next') {
        if (this.pagination.currentPage < this.pagination.lastPage) {
          this.pagination.currentPage++
        }
      }
      if (config.option === 'prev') {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage--
        }
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        if (config.page === '...') return
        this.pagination.currentPage = parseInt(config.page)
      }
      this.setPagination()
      await this.getdata()
      $('html,body').scrollTop(1000)
    },

    initDatatable() {
      setTimeout(() => {
        $.fn.dataTable.moment("DD MMMM YYYY");

        var t = $("#nonberusahaAdminUPT").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          // stateSave: true,
          // order: [[8, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 3, right: 1 },
          scrollX: true,
          dom: "Bfrtip",
          // fnRowCallback: function (
          //   nRow,
          //   aData,
          //   iDisplayIndex,
          //   iDisplayIndexFull
          // ) {
          //   //debugger;
          //   var index = iDisplayIndexFull + 1;
          //   $("td:first", nRow).html(index);
          //   return nRow;
          // },
          columnDefs: [
            // { type: 'date-dd-mmm-yyyy', targets: 8 },
            {
              targets: 0,
              render: function (data, type, row, meta) {
                // console.log(meta.row);
                // console.log(type == 'export' ? meta.row : data);
                return type == "export" ? meta.row + 1 : data;
              },
              rowCallback: function (row, data, index) {
                console.log(data);
                if (data[0] == "OK") {
                  $(row).addClass("green");
                } else if (data[0] == "Before") {
                  $(row).addClass("orange");
                }
              },
            },
          ],
          buttons: [
            // 'excel', 'pdf',
            // {
            //   extend: "excelHtml5",
            //   title: "DATA PEMOHON",
            //   text: '<i class="fa fa-file-text-o"></i> Excel',
            //   className: "btn text-white btn-success",
            //   exportOptions: {
            //     columns: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            //     orthogonal: "export",
            //     // format: {
            //     //     header: function ( data, columnIdx ) {
            //     //         if(columnIdx==7 || columnIdx==8 || columnIdx==9){
            //     //         return 'Aktivitas ' + data;
            //     //         }
            //     //         else if(columnIdx==10 || columnIdx==11){
            //     //           return 'Verifikasi Dokumentatif ' + data;
            //     //         }
            //     //         else if(columnIdx==12 || columnIdx==13){
            //     //           return 'Verifikasi Lapangan ' + data;
            //     //         }
            //     //         else if(columnIdx==14 || columnIdx==15){
            //     //           return 'File BA ' + data;
            //     //         }
            //     //         else if(columnIdx==16 || columnIdx==17 || columnIdx==18){
            //     //           return 'Predikat ' + data;
            //     //         }
            //     //         else{
            //     //           return data;
            //     //         }
            //     //     },
            //     //     body: function(data, row, column, node) {
            //     //         data = $('<p>' + data + '</p>').text();
            //     //         return data.replace(',', '.');
            //     //     },
            //     // }
            //   },
            //   filename: function () {
            //     var today = new Date();
            //     // var n = d.getTime();
            //     var date =
            //       today.getFullYear() +
            //       "-" +
            //       (today.getMonth() + 1) +
            //       "-" +
            //       today.getDate();

            //     return "Data Pemohon " + date;
            //   },
            // },
          ],
        });

        // t.on( 'click', 'button', function (e) {
        //     var closestRow = $(this).closest('tr');
        //     var data = t.row( $(this).parents(closestRow)).data();
        //     alert(data[0])
        //     // alert( t.cell( $(this).closest('tr').prev('tr'), $(this).attr('data-dtr-index') ).data() );
        // e.stopPropagation();

        // } );

        // if(hasFixedColumns){
        //   t.fixedColumns().update();
        // }else{
        //   const $actionColumn = $('#tablesatu th:last-child');
        //   $actionColumn.removeClass('dtfc-fixed-right');
        //   $actionColumn.css('position', '');
        // }

        // t.on("order.dt search.dt", function () {
        //   t.column(0, { search: "applied", order: "applied" })
        //     .nodes()
        //     .each(function (cell, i) {
        //       cell.innerHTML = i + 1;
        //     });
        // }).draw();
      }, 300);
    },

    simpanSuratTugas() {
      let api = "";
      if (this.dataSuratTugas.id == null) {
        api = "api/surat_tugas_nonberusaha";
        this.$validator.validateAll("form-1").then((result) => {
          if (result) {
            this.$nextTick(() => {
              this.$bvModal.hide("modal-surat-tugas");
            });
            this.$loading(true);
            axios
              .post(
                this.baseapi + api,
                {
                  id_permohonan: this.id_Permohonan,
                  menimbang: this.dataSuratTugas.menimbang,
                  dasar: this.dataSuratTugas.dasar,
                  kepada: this.dataSuratTugas.kepada,
                  untuk: this.dataSuratTugas.untuk,
                  catatan_surat: this.dataSuratTugas.catatan_surat,
                  paraf_persetujuan: this.dataSuratTugas.paraf_persetujuan,
                  penandatangan: this.dataSuratTugas.penandatangan,
                  paragraf_penutup: this.dataSuratTugas.paragraf_penutup,
                  tempat_ttd: this.dataSuratTugas.tempat_ttd,
                  tanggal_surat: this.dataSuratTugas.tanggal_surat,
                },
                {
                  headers: {
                    "Content-type": "application/json",
                    Authorization: `Bearer ` + this.user.accessToken,
                  },
                }
              )
              .then((res) => {
                this.$toasted.success("Berhasil Ditambah");
                this.getdata();
                this.dataSuratTugas = [];
                this.dataTTD = [];
                //   this.dataUser = []
                this.$loading(false);

                // Wait until the models are updated in the UI
                return res;
              })
              .catch((err) => {
                console.log(err);
                this.$loading(false);
                this.$toasted.error(err.response.data.message);
                return err;
              });
          }
        });
      } else {
        api = "api/surat_tugas_nonberusaha/" + this.dataSuratTugas.id;
        this.$validator.validateAll("form-1").then((result) => {
          if (result) {
            this.$nextTick(() => {
              this.$bvModal.hide("modal-surat-tugas");
            });
            this.$loading(true);
            axios
              .put(
                this.baseapi + api,
                {
                  id_permohonan: this.id_Permohonan,
                  menimbang: this.dataSuratTugas.menimbang,
                  dasar: this.dataSuratTugas.dasar,
                  kepada: this.dataSuratTugas.kepada,
                  untuk: this.dataSuratTugas.untuk,
                  catatan_surat: this.dataSuratTugas.catatan_surat,
                  paraf_persetujuan: this.dataSuratTugas.paraf_persetujuan,
                  penandatangan: this.dataSuratTugas.penandatangan,
                  paragraf_penutup: this.dataSuratTugas.paragraf_penutup,
                  tempat_ttd: this.dataSuratTugas.tempat_ttd,
                  tanggal_surat: this.dataSuratTugas.tanggal_surat,
                },
                {
                  headers: {
                    "Content-type": "application/json",
                    Authorization: `Bearer ` + this.user.accessToken,
                  },
                }
              )
              .then((res) => {
                this.$toasted.success("Berhasil Diubah");
                this.getdata();
                this.dataSuratTugas = [];
                this.dataTTD = [];
                //   this.dataUser = []
                this.$loading(false);

                // Wait until the models are updated in the UI
                return res;
              })
              .catch((err) => {
                console.log(err);
                this.$loading(false);
                this.$toasted.error(err.response.data.message);
                return err;
              });
          }
        });
      }
    },

    finalSuratTugas() {
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-final-surat");
          });
          axios
            .put(
              this.baseapi +
              "api/surat_tugas_nonberusaha/" +
              this.dataSuratTugas.id,
              {
                nomor_surat: this.dataSuratTugas.nomor_surat,
                status_pembuatan: "Selesai",
              },
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Disimpan");
              this.getdata();
              this.dataSuratTugas = [];
              this.dataTTD = [];
              //   this.dataUser = []

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    finalUndangan() {
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-final-undangan");
          });
          axios
            .put(
              this.baseapi + "api/undangan_nonberusaha/" + this.dataUndangan.id,
              {
                nomor_surat: this.dataUndangan.nomor_surat,
                status_pembuatan: "Selesai",
              },
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Disimpan");
              this.getdata();
              this.dataUndangan = [];
              this.dataPerDokumen = [];

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    getDataUserAdmin() {
      let apiPIC;
      apiPIC = "api/user?filter=role,=,admin_kkp;role,=,admin_upt&concat=or";
      axios
        .get(this.baseapi + apiPIC, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataUserPICVerdok = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    detailPICVerdok(data) {
      this.formpicverdok.id = data.id;
      this.formpicverdok.id_pic_verdok = data.id_pic_verdok;
      console.log(this.formpicverdok.id_pic_verdok);

      // this.$nextTick(() => {
      //   this.$bvModal.show("modal-pic-verdok-nonberusaha");
      // });
    },

    simpanPICVerdok() {
      axios
        .post(
          this.baseapi + "api/permohonan_nonberusaha/" + this.formpicverdok.id,
          {
            id_pic_verdok: this.formpicverdok.id_pic_verdok,
          },
          {
            // status_tandatangan_undangan: true,

            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          this.$toasted.success("Berhasil Disimpan");
          this.$bvModal.hide("modal-pic-verdok-nonberusaha");
          this.getdata();
          this.formpicverdok.id = null;
          this.formpicverdok.id_pic_verdok = null;
          return res;
        })
        .catch((err) => {
          console.log(err);
          this.$toasted.error(err.response.data.message);
          return err;
        });
    },

    exportData() {
      this.$loading(true);
      const api = `api/permohonan_nonberusaha` +
        `?sort=${this.sort.field},${this.sort.direction}` +
        `&filter=tipe_pemohon,=,${this.tipe};id_admin,=,${this.user.id};status_permohonan,!=,Permohonan telah dibuat oleh pemohon${this.search.value !== '' ? `;${this.search.field},${this.search.field === 'tanggal_proses' || this.search.field === 'tanggal_pada_permohonan' ? '>=' : 'like'},${this.search.value}` : ''}`
      axios.get(this.baseapi + api, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then((res) => {
        const worksheetData = [
          ['Data Pemohon'],
          ['No', 'Nomor Pemohon', 'Instansi Pemohon', 'Jenis Kegiatan', 'Nama Perairan', 'Provinsi', 'Status Verdok', 'Status Permohonan', 'Tgl. Permohonan', 'Tgl. Verdok', 'PIC Pentek']
        ]
        const merge = [{ s: { c: 0, r: 0 }, e: { c: worksheetData[1].length - 1, r: 0 }, }]
        res.data.data.map((d, i) => {
          worksheetData.push([
            i + 1,
            d.nomor_permohonan,
            d.instansi_pemohon,
            d.jenis_kegiatan,
            d.nama_perairan,
            d.provinsi,
            d.status_verdok,
            d.status_permohonan,
            d.tanggal_permohonan,
            d.tanggal_lolos_verifikasi_administrasi,
            d.pic_name,
          ])
        })

        const workbook = xlsx.utils.book_new();
        const worksheet = xlsx.utils.aoa_to_sheet(worksheetData);
        worksheet["!merges"] = merge;
        xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const d = new Date();
        xlsx.writeFile(workbook, `Data Pemohon ${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}.xlsx`);
      }).catch((err) => {
        Swal.fire('Gagal', 'Gagal mengekspor data', 'error')
      }).finally(() => {
        this.$loading(false);
      })
    },
  },
};
</script>